import Hidden from 'components/Hidden';
import React, { Fragment, useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from 'utils/makeStylesAdapter';
import { Drawer, Paper, Typography } from '@mui/material';
import useRouter from 'utils/useRouter';
import { Button } from 'components';
import NewNavBarContent from './NewNavBarContent';
import { setUrlCallbackLogin } from 'utils/setUrlCallbackLogin';
import { OLD_URLS } from 'constants/old-urls';
import ModalVersion from '../ModalVersion';
import { toast } from 'react-toastify';
import { useParameterKeys } from 'hooks/useParameterKeys';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    overflowY: 'auto',
  },
  content: {
    //paddingLeft: theme.spacing(2)
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content',
  },
  avatar: {
    width: 60,
    height: 60,
  },
  name: {
    marginTop: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(2),
  },
  navigation: {
    //marginTop: theme.spacing(2)
  },
  footerContainer: {
    position: 'flex',
    bottom: 0,
    width: '100%',
  },
  versionButton: {
    position: 'flex',
    bottom: 0,
    padding: theme.spacing(2),
  },
  versionText: {
    textTransform: 'none',
    fontSize: '14px',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: '21px',
    letterSpacing: '-0.05px',
  },
}));

const NavBar = props => {
  const { openMobile, onMobileClose, className, ...rest } = props;

  const { applyLightTheme } = useParameterKeys();
  const [frontVersion, setFrontVersion] = useState('');
  const [isModalOpen, setModalOpen] = useState(false);

  const classes = useStyles();
  const router = useRouter();

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const getFrontVersion = () => {
    try {
      const packageData = require('../../../../../package.json');
      return packageData.version;
    } catch (error) {
      toast.error('Erro ao buscar a versão do front');
      return null;
    }
  };

  useEffect(() => {
    if (openMobile) {
      onMobileClose && onMobileClose();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.location.pathname]);

  useEffect(() => {
    const url = setUrlCallbackLogin();
    localStorage.setItem(OLD_URLS.user_and_prosecutor, url);
    setFrontVersion(getFrontVersion());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href]);

  return (
    <Fragment>
      <Hidden lgUp>
        <Drawer anchor="left" onClose={onMobileClose} open={openMobile} variant="temporary">
          <div {...rest} className={clsx(classes.root, className)}>
            <NewNavBarContent />
            <div className={classes.footerContainer}>
              <Button className={classes.versionButton} onClick={handleOpenModal}>
                <Typography style={{ color: applyLightTheme ? '#000000' : '#C1C6C9' }} className={classes.versionText}>
                  Versão: {frontVersion}
                </Typography>
              </Button>
            </div>
          </div>
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Paper {...rest} className={clsx(classes.root, className)} elevation={1} square>
          <NewNavBarContent />
          <div className={classes.footerContainer}>
            <Button className={classes.versionButton} onClick={handleOpenModal}>
              <Typography style={{ color: applyLightTheme ? '#000000' : '#FFFFFF' }} className={classes.versionText}>
                Versão: {frontVersion}
              </Typography>
            </Button>
          </div>
        </Paper>
      </Hidden>
      {isModalOpen && (
        <ModalVersion frontVersion={frontVersion} open={isModalOpen} onClose={handleCloseModal} />
      )}
    </Fragment>
  );
};

NavBar.propTypes = {
  className: PropTypes.string,
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default NavBar;
